// The cards over a screen (R-U19): the stack in the address (shell/cards.ts) drawn by the core's modal stack, each card the same single
// as the record's page, with «открыть страницей» and «закрыть». The frame mounts it once, over every route.

import { recordTitle } from '@confdeck/core-shared';
import { RecordView } from '../record/RecordView.tsx';
import { useMeta, useSync } from '../sync/react.tsx';
import { ModalStack } from '../ui/ModalStack.tsx';
import { cardsOf, closeCardsFrom, closeTopCard, openCard } from './cards.ts';
import { navigate, recordHref, useLocation } from './router.ts';

export function CardStack() {
  const { search } = useLocation();
  const cards = cardsOf(search);
  const client = useSync();
  const meta = useMeta();
  // Each layer is named by its record: a screen reader and «Вернуться: …» tell the cards apart (review P3-3).
  const name = (id: string) => { const r = client.store.record(id); return r ? `${meta.type(r.typeId)?.name ?? 'Запись'} «${recordTitle(r, meta)}»` : 'Карточка записи'; };
  return (
    <ModalStack onClose={closeCardsFrom} layers={cards.map((id) => ({
      key: id, label: name(id), size: 'card' as const,
      content: <RecordView id={id} inStack onClose={closeTopCard} onOpen={openCard} embedded={{ onExpand: () => navigate(recordHref(id)) }} />,
    }))} />
  );
}
